module.exports = __webpack_public_path__ + "files/84fb2e7a73776cad4ffc9972fc8a7b24.svg";